import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=179b6131&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b6131",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179b6131')) {
      api.createRecord('179b6131', component.options)
    } else {
      api.reload('179b6131', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=179b6131&scoped=true&", function () {
      api.rerender('179b6131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8yK2fSSWlyC8y/JS/comp/Accordion.vue"
export default component.exports